import { useQueryClient } from '@tanstack/react-query';

import type { FC } from 'react';
import { Navigate } from 'react-router';
import type { AxiosResponse } from 'axios';

import type { UserRole, UserRoleAccess } from '@/types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles: UserRole[];
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({
  children,
  requiredRoles,
}) => {
  const queryClient = useQueryClient();
  const userRoleAccess = queryClient.getQueryData<
    AxiosResponse<UserRoleAccess>
  >(['userRoleAccess']);

  if (
    !userRoleAccess?.data?.user?.roles?.some((role) =>
      requiredRoles.includes(role),
    )
  ) {
    return <Navigate to="/" />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
